const browsers = {
	js: true,
	mobile: (navigator.userAgent.match(/mobi/i)),
	firefox: navigator.userAgent.indexOf('Firefox') > -1,
	webKit: !!navigator.userAgent.match(/webkit/i),
	chrome: navigator.userAgent.indexOf('Chrome') > -1,
	safari: navigator.userAgent.indexOf('Safari') > -1,
	// eslint-disable-next-line piggyback/no-restricted-global-extend
	opera: !!window.opera || /opera|opr/i.test(navigator.userAgent),
	android: navigator.userAgent.indexOf('Android') > -1,
	// eslint-disable-next-line piggyback/no-restricted-global-extend
	iOs: (!!navigator.userAgent.match(/iPad|iPhone|iPod/g)) && !window.MSStream,
	ie: navigator.userAgent.indexOf('Trident/') > -1,
	edge: navigator.userAgent.indexOf('Edge/') > -1
};

browsers.webKit = !browsers.edge && browsers.webKit;
browsers.chrome = !browsers.edge && browsers.chrome;
browsers.safari = !browsers.edge && browsers.safari && !browsers.chrome;
browsers.ms = browsers.ie || browsers.edge;
let htmlClasses = '';
for (const name in browsers) {
	if (browsers.hasOwnProperty(name) && browsers[name]) {
		htmlClasses += ' ' + name;
	}
}
const html = document.querySelector('html');
html.classList.remove('no-js');
html.className = html.className + htmlClasses;
